// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { components } from 'react-select';

import { Icon } from 'components/Icon';

export function DropdownIndicator(props: { menuIsOpen: boolean }) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.DropdownIndicator {...props}>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/destructuring-assignment */}
      {props.menuIsOpen ? (
        <Icon initialColorName="todo-replace-me" name="chevron-up" size={15} />
      ) : (
        <Icon
          initialColorName="todo-replace-me"
          name="chevron-down"
          size={15}
        />
      )}
    </components.DropdownIndicator>
  );
}
